DigiTickets.MembershipRenewalDateTypes = Object.freeze({
    TODAY: 'TODAY',
    EXPIRY: 'EXPIRY',
    OTHER: 'OTHER',
    NONE: 'NONE'
});
